import React, { useCallback, useState } from 'react';

import styles from './TrainSHomeStationSwitch.module.scss';
import clsx from 'clsx';

interface ITrainSHomeStationSwitchProps {
  onClick: () => void;
}

const TrainSHomeStationSwitch: React.FC<ITrainSHomeStationSwitchProps> = ({ onClick }) => {
  const [spinning, setSpinning] = useState<boolean>(false);
  const onClickSwitch = useCallback(() => {
    onClick();
    setSpinning(true);
  }, [onClick]);

  return (
    <button className={styles.container} onClick={onClickSwitch}>
      <span
        className={clsx(styles.rotation, spinning ? styles.spinning : '')}
        onAnimationEnd={() => setSpinning(false)}
      />
    </button>
  );
};

export default TrainSHomeStationSwitch;
